import React, { useEffect, useMemo, useState } from "react";
import { api, asset, IMG } from "@/lib/api";
import CourseCard from "@/components/courses/CourseCard";
import { PageHeader } from "@/components/shared/SectionHeader";
import { Search } from "lucide-react";

const TRACKS = ["All", "Ownership Academy", "Certification Track", "Breeder Academy", "Cognitive Development Academy", "Nutrition Academy", "Rescue Academy"];

export default function Learn() {
  const [courses, setCourses] = useState([]);
  const [track, setTrack] = useState("All");
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/courses").then(r => setCourses(r.data)); }, []);

  const filtered = useMemo(() => {
    return courses.filter(c => (track === "All" || c.track === track) &&
      (q === "" || (c.title + " " + c.subtitle + " " + c.instructor).toLowerCase().includes(q.toLowerCase())));
  }, [courses, track, q]);

  return (
    <div>
      <PageHeader
        eyebrow="Learning Center"
        title="A university built for the wolfdog world."
        description="Rigorous curricula in ownership, cognition, nutrition, breeding ethics, rescue and legislation — taught by working professionals and cognitive scientists."
        image={IMG.forest}
      />

      <section className="container-x py-14">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-2">
            {TRACKS.map(t => (
              <button
                key={t}
                onClick={() => setTrack(t)}
                data-testid={`learn-filter-${t.toLowerCase().replace(/\s+/g,'-')}`}
                className={
                  "text-xs uppercase tracking-[0.2em] font-semibold px-3 py-2 rounded-full border transition " +
                  (track === t ? "bg-primary text-primary-foreground border-primary" : "border-border text-muted-foreground hover:border-foreground/40")
                }
              >
                {t}
              </button>
            ))}
          </div>
          <div className="relative w-full md:w-80">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <input
              value={q}
              onChange={e => setQ(e.target.value)}
              placeholder="Search courses, instructors…"
              data-testid="learn-search"
              className="w-full pl-9 pr-4 py-3 text-sm rounded-md border border-border bg-background focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered.map(c => <CourseCard key={c.id} c={c} />)}
        </div>
        {filtered.length === 0 && (
          <div className="text-center py-24 text-muted-foreground">No courses match those filters.</div>
        )}
      </section>
    </div>
  );
}
